/* Header transparency over the opener.
   An IntersectionObserver on the opener rather than a scroll listener:
   it fires twice per page instead of on every frame, and it needs no
   height measurement, so it cannot drift when the opener's scroll_length
   setting changes. */
(() => {
  'use strict';
  const header = document.querySelector('[data-sadil-header]');
  if (!header) return;
  const mode = header.dataset.openerMode || 'hidden';
  const stateClass = mode === 'hidden' ? 'sadil-header--hidden'
                   : mode === 'transparent' ? 'sadil-header--over' : null;
  const opener = document.querySelector('.sadil-opener');

  // No opener on this page (or mode is 'solid'): the bar is simply solid.
  if (!stateClass || !opener) {
    header.classList.remove('sadil-header--hidden', 'sadil-header--over');
  } else {
    new IntersectionObserver(
      ([entry]) => header.classList.toggle(stateClass, entry.isIntersecting),
      // Flips the moment the opener's last pixel clears the top of the bar.
      { rootMargin: '-64px 0px 0px 0px', threshold: 0 }
    ).observe(opener);
  }

  /* The bag opens the drawer.

     It stays an <a href="/cart"> in the markup on purpose: with no JS,
     or before this file runs, it is still a working link to the cart
     page. JS upgrades it to the drawer. The bug this fixes is that the
     bag was ONLY ever the link — the drawer existed, listened on
     sadil:cart-open, and nothing in the header ever dispatched it, so
     clicking the bag left the page instead of opening the panel.

     Modified clicks (new tab, middle click) are left alone: someone
     asking for a new tab wants the cart page, not a drawer. */
  document.addEventListener('click', (e) => {
    const bag = e.target.closest('.sadil-header__bag');
    if (!bag) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
    if (!document.querySelector('[data-sadil-cart] [data-cart-drawer]')) return;
    e.preventDefault();
    document.dispatchEvent(new CustomEvent('sadil:cart-open'));
  });

  // Cart count, kept in step with Dawn's cart events.
  document.addEventListener('cart:updated', (e) => {
    const count = e.detail?.cart?.item_count;
    if (typeof count !== 'number') return;
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.classList.toggle('is-empty', count === 0);
    });
  });
})();
